













import type { PropType } from "vue"
import type { pagination } from "@/@types/base"
import { Vue } from "vue-property-decorator";

export default Vue.extend({
  name: "Pagination",
  props: {
    size      : { type: String, default: "small" },
    pagination: { type: Object as  PropType<pagination>, default: { current: 1, size: 10 } },
    total     : { type: Number, default: 0 },
    options   : { type: Array, default() { return ["10", "100", "1000", "5000", "10000"] } },
    show_total: { type: Function, default: (total: number) => `总计 ${total} 条记录` }
  },
  watch: {
    pagination: {
      handler() {
        this.$emit("search")
      },
      deep: true
    }
  }
})

